import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { GeometryEventInput } from '../models/geometry.js'

const serviceSource = 'droidmap.backend.geometry-service'

export const GeometryCreated = new BaseEventBuilder<
  GeometryEventInput,
  'Geometry Created'
>(serviceSource, 'Geometry Created')

export const GeometryUpdated = new BaseEventBuilder<
  GeometryEventInput,
  'Geometry Updated'
>(serviceSource, 'Geometry Updated')

export const GeometryDeleted = new BaseEventBuilder<
  GeometryEventInput,
  'Geometry Deleted'
>(serviceSource, 'Geometry Deleted')
